import styled, { css } from 'styled-components'

const FullWidthCardStyle = css`
  width: 100%;
`

const ShadowStyle = css`
  box-shadow: ${({ theme }) => `0 1px 4px 0 ${theme.shadow}, 0 0px 4px 0 ${theme.shadow}`};
`

export const Card = styled.div`
  border-radius: 4px;
  color: ${({ theme }) => theme.text};
  border: 1px solid ${({ theme }) => theme.border};
  background-color: ${({ theme }) => theme.snow};

  ${({ withShadow }) => withShadow && ShadowStyle}
  ${({ fullWidth }) => fullWidth && FullWidthCardStyle}

  & .recharts-wrapper {
    margin-left: -20px;
  }
`

const CardHeaderWithBorderStyle = css`
  border-bottom: 1px solid ${({ theme, borderColor }) => borderColor || theme.border};
`

const CardHeaderWithBackgroundStyle = css`
  background-color: ${({ theme }) => theme.backgroundSecondary};
`

export const CardHeader = styled.div`
  width: 100%;
  padding: .8rem 1.5rem;
  color: ${({ theme }) => theme.text};
  ${({ border }) => border && CardHeaderWithBorderStyle}
  ${({ bg }) => bg && CardHeaderWithBackgroundStyle}
`

export const CardContent = styled.div`
  padding: 1.5rem;
`

export const CardFooter = styled.div`
  width: 100%;
  background-color: inherit;
  color: ${({ theme }) => theme.text};
  padding: .8rem 1.5rem;
  border-top: 1px solid ${({ theme }) => theme.border};
`



// WEBPACK FOOTER //
// ./src/Components/Card/Card.jsx